<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col md="12" v-if="ordersReason" class="mb-2">
            <h4 id="traffic" class="card-title mb-0">Clientes Habilitados</h4>
            <div class="small text-muted">
              <b>{{this.ordersReason.reference}} - {{this.ordersReason.name}}</b>
            </div>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col md="12" class="mb-3">
            <FindObject render="search"
                        type="customers"
                        @select-object="agregarCliente($event)"
                        :valueID="0"
                        :key="componentKey" />
          </b-col>

          <b-col md="12">
            <b-form-input v-model="filtro.texto" placeholder="Buscar en la lista..." size="sm" class="mb-2"></b-form-input>

            <b-table class="mb-0"
                    responsive="sm"
                    head-variant="dark"
                    :hover="true"
                    :small="true"
                    :items="filteredItems"
                    :fields="fields"
                    v-if="tableItems.length">

              <template v-slot:cell(deposit_casilda)="row">
                <b-form-checkbox v-model="crud.selected[row.item.customersID].deposit_casilda"></b-form-checkbox>
              </template>

              <template v-slot:cell(deposit_bsas)="row">
                <b-form-checkbox v-model="crud.selected[row.item.customersID].deposit_bsas"></b-form-checkbox>
              </template>

              <template v-slot:cell(f_action)="row">
                <b-button size="sm" variant="outline-danger" class="pull-right" @click="quitarCliente(row.item.customersID)" v-b-tooltip.hover title="Quitar">
                  <i class="fa fa-trash"></i>
                </b-button>
              </template>
            </b-table>
            <b-alert v-else variant="warning" show>Ningún cliente habilitado todavía para este motivo</b-alert>
          </b-col>
        </b-row>
      </b-card>

      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <b-button type="button" variant="outline-dark" size="sm" @click="$router.go(-1)">
              <i class="fa fa-angle-double-left"></i>
              Volver
            </b-button>
          </b-col>

          <b-col>
            <b-button variant="dark" class="pull-right" size="sm" @click="save()">Guardar</b-button>
          </b-col>
        </b-row>
      </b-card>
    </b-col>
  </b-row>
</template>
<script>
  import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import FindObject from '@/components/inc/find/findObject'

  export default {
    components: {
      FindObject,
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PEDIDOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'crudOrdersReasonCustomers',
          elements: {}
        },
        fields: [
          {key: 'nombre', label: 'Cliente'},
          {key: 'deposit_casilda', label: 'Depósito Casilda'},
          {key: 'deposit_bsas', label: 'Depósito BsAs'},
          {key: 'f_action', label: ''},
        ],
        filtro: {
          texto: '',
        },
        crud: {
          selected: {},
        },
        componentKey: 0,
        ordersReasonID: 0,
        ordersReason: null,
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */
    },
    mounted() {
      this.ordersReasonID = this.$route.params.reasonID

      this.loadOrdersReason()
      this.loadClientesHabilitados()
    },
    computed: {
      tableItems() {
        return Object.keys(this.crud.selected).map(customersID => ({
          customersID: customersID,
          nombre: this.crud.selected[customersID].nombre,
        }))
      },
      filteredItems() {
        var texto = this.filtro.texto.trim().toLowerCase()
        if(!texto) {
          return this.tableItems
        }

        return this.tableItems.filter(item => item.nombre.toLowerCase().indexOf(texto) !== -1)
      },
    },
    methods: {
      loadOrdersReason() {
        var result = serviceAPI.mostrarMotivos(this.ordersReasonID)

        result.then((response) => {
          this.ordersReason = response.data
        })
      },
      loadClientesHabilitados() {
        let loader = this.$loading.show();
        var result = serviceAPI.obtenerClientesPorMotivo(this.ordersReasonID)

        result.then((response) => {
          var selected = {}

          response.data.forEach(item => {
            var nombre = item.customer ? item.customer.name : ('Cliente #' + item.customers_id)
            if(item.customer && item.customer.code) {
              nombre = item.customer.code + ' | ' + nombre
            }

            selected[item.customers_id] = {
              nombre: nombre,
              deposit_casilda: !!item.deposit_casilda,
              deposit_bsas: !!item.deposit_bsas,
            }
          })

          this.crud.selected = selected
          loader.hide()
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error))
        });
      },
      agregarCliente(object) {
        if(!object) {
          return
        }

        if(this.crud.selected[object.id]) {
          this.$awn.alert('Ese cliente ya está en la lista')
        } else {
          var nombre = object.code ? object.code + ' | ' + object.name : object.name
          this.$set(this.crud.selected, object.id, {
            nombre: nombre,
            deposit_casilda: true,
            deposit_bsas: false,
          })
        }

        this.componentKey += 1
      },
      quitarCliente(customersID) {
        this.$delete(this.crud.selected, customersID)
      },
      save() {
        let loader = this.$loading.show();

        var items = Object.keys(this.crud.selected).map(customersID => ({
          customers_id: customersID,
          deposit_casilda: this.crud.selected[customersID].deposit_casilda,
          deposit_bsas: this.crud.selected[customersID].deposit_bsas,
        }))

        var payload = {
          reason_id: this.ordersReasonID,
          items: items,
        }

        serviceAPI.guardarClientesPorMotivo(payload)
        .then((response) => {
          loader.hide()
          this.$awn.success("Datos guardados con éxito");
        })
        .catch(error => {
          loader.hide()
          this.$awn.alert(Error.showError(error));
        })
      },
    }
  }
</script>
<style>

</style>
